import React from 'react';
import { useAuth } from '../context/shared/AuthContext';
import PatientHeader from './PatientHeader';
import TherapistHeader from './TherapistHeader';

const Header: React.FC = () => {
    const { user } = useAuth();

    // If no user, show a simple header
    if (!user) {
        return (
            <div className="bg-gradient-to-r from-gray-600 to-gray-700 shadow-lg">
                <div className="max-w-[768px] md:max-w-[1200px] mx-auto px-4">
                    <div className="flex justify-between items-center h-16">
                        <div className="flex items-center space-x-2">
                            <span role="img" aria-label="brain" className="text-2xl">🧠</span>
                            <span className="text-xl font-bold text-white">Mentra</span>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    // Determine user role and render appropriate header
    const userRole = user.role || 'patient'; // Default to patient if role not set
    
    if (userRole === 'therapist' || userRole === 'therapist_asst' || userRole === 'admin') {
        return <TherapistHeader />;
    }
    
    // Default to patient header
    return <PatientHeader />;
};

export default Header;